module.exports = __webpack_public_path__ + "img/icon-arrow-neutral.a0468fa7.svg";